var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProgressbarVersicherung(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    enableBackground: "new 0 0 300 300",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_97"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_96"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_95"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_94"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_93"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_92"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_91"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_90"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_89"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_88"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_87"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_86"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_85"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_84"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_83"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_82"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_81"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_80"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_79"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_78"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_77"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_76"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_75"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_74"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_73"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_72"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_71"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_70"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_69"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_68"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_67"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_66"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_65"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_64"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_63"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_62"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_61"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_60"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M150,19C77.767,19,19,77.767,19,150s58.767,131,131,131s131-58.767,131-131S222.233,19,150,19z  M220.01,139.259c0,2.922-2.37,5.293-5.294,5.293s-5.293-2.371-5.293-5.293v-32.261c-6.583-0.588-18.305-3.008-33.765-11.772 c-13.521-7.67-21.332-14.854-25.652-19.833v16.973h3.968v126.272h-3.968v14.218c56.851-39.192,59.417-49.389,59.417-66.63v-8.12 c0-2.923,2.369-5.293,5.293-5.293s5.294,2.371,5.294,5.293v8.12c0,22.9-5.777,35.508-67.019,77.421l-2.989,2.046l-2.989-2.046 C85.77,201.734,79.99,189.127,79.99,166.227V95.782l5.974,0.771c0.065,0.006,12.496,1.177,33.159-10.538 c20.794-11.796,26.062-21.863,26.111-21.962l4.768-9.909l4.771,9.909c0.02,0.042,5.413,10.223,26.109,21.964 c20.662,11.715,33.091,10.543,33.213,10.531l5.857-0.627l0.057,5.884V139.259z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#137F7B",
    d: "M124.348,95.226c-15.461,8.765-27.186,11.184-33.771,11.772v59.229c0,17.241,2.568,27.438,59.425,66.632 l0.004-0.002v-14.218h-3.974V92.366h3.974V75.393c0-0.001-0.004-0.001-0.004-0.001C145.68,80.371,137.867,87.554,124.348,95.226z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M150,11C73.355,11,11,73.355,11,150s62.355,139,139,139s139-62.355,139-139S226.645,11,150,11z M150,281 c-72.233,0-131-58.767-131-131S77.767,19,150,19s131,58.767,131,131S222.233,281,150,281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M214.096,96.547c-0.122,0.013-12.551,1.184-33.213-10.531c-20.696-11.741-26.09-21.922-26.109-21.964 l-4.771-9.909l-4.768,9.909c-0.05,0.099-5.317,10.166-26.111,21.962C98.46,97.729,86.029,96.559,85.964,96.553l-5.974-0.771 v70.445c0,22.9,5.779,35.508,67.022,77.421l2.989,2.046l2.989-2.046c61.241-41.913,67.019-54.521,67.019-77.421v-8.12 c0-2.923-2.37-5.293-5.294-5.293s-5.293,2.371-5.293,5.293v8.12c0,17.241-2.566,27.438-59.417,66.63l-0.004,0.002 c-56.856-39.194-59.425-49.391-59.425-66.632v-59.229c6.585-0.588,18.31-3.008,33.771-11.772 c13.52-7.672,21.332-14.855,25.654-19.834c0,0,0.004,0,0.004,0.001c4.32,4.979,12.132,12.163,25.652,19.833 c15.46,8.765,27.182,11.184,33.765,11.772v32.261c0,2.922,2.369,5.293,5.293,5.293s5.294-2.371,5.294-5.293v-37.455l-0.057-5.884 L214.096,96.547z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#333333",
    points: "146.032,92.366 146.032,218.638 150.006,218.638 153.974,218.638 153.974,92.366 150.006,92.366 "
  }))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_58"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_57"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_56"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_55"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_53"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_52"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_51"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_49"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_48"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_47"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_46"
  })), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45"
  })), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_44"
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42"
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_41"
  })), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_40"
  })), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_39"
  })), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_38"
  })), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_37"
  })), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_36"
  })), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressbarVersicherung);
export default __webpack_public_path__ + "static/media/icon_progressbar_versicherung.ed4bdf7a3c499a307783155b8bc35d1a.svg";
export { ForwardRef as ReactComponent };